import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import './AppFooter.css';

const COMPANY_LABEL = 'Developed by Sarjen Systems Pvt. Ltd.';

const AppFooter = () => {
  const [versionText, setVersionText] = useState('');
  const [sarjenUrl, setSarjenUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('App/ProductVersionText');
        const text = data?.productVersionText?.trim();
        const url = data?.sarjenUrl?.trim();
        if (!cancelled) {
          if (text) setVersionText(text);
          if (url) setSarjenUrl(url);
        }
      } catch {
        /* keep fallback */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <footer className="app-footer">
      <span className="app-footer-version">{versionText}</span>
      {sarjenUrl ? (
        <a
          className="app-footer-company app-footer-company-link"
          href={sarjenUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {COMPANY_LABEL}
        </a>
      ) : (
        <span className="app-footer-company">{COMPANY_LABEL}</span>
      )}
    </footer>
  );
};

export default AppFooter;
